export default __webpack_public_path__ + "static/media/timer.cc163a72.svg";